var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4375 3.98438V0H1.57812C1.18848 0 0.875 0.313477 0.875 0.703125V14.2969C0.875 14.6865 1.18848 15 1.57812 15H11.4219C11.8115 15 12.125 14.6865 12.125 14.2969V4.6875H8.14062C7.75391 4.6875 7.4375 4.37109 7.4375 3.98438ZM12.125 3.57129V3.75H8.375V0H8.55371C8.74121 0 8.91992 0.0732422 9.05176 0.205078L11.9199 3.07617C12.0518 3.20801 12.125 3.38672 12.125 3.57129Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentSmall);
export default __webpack_public_path__ + "static/media/document-small.bfdd8757d6a6a464221f385154eeb695.svg";
export { ForwardRef as ReactComponent };